import SectionNavigation from "./components/sections/SectionNavigation.tsx";
import SectionCheckIn from "./components/sections/SectionCheckIn.tsx";
import SectionStories from "./components/sections/SectionStories";
import { useTranslation } from "react-i18next";
import SectionEntrance from "./components/sections/SectionEntrance.tsx";
import PageWrapper from "@/components/PageWrapper";
import PushNotification from "@/components/PushNotification/PushNotification.tsx";
import HomeTaskList from "./components/HomeTaskList.tsx";
export default function HomePage() {
  const { t } = useTranslation();

  // return <Navigate to={'/auth'} />

  return (
    <PageWrapper back={false}>
      <div className="bg-[linear-gradient(134deg,_#21212D_0%,_#0E0E14_76.59%)]">
        <SectionEntrance />
        <SectionStories />
        <SectionNavigation className="my-4" />
        <SectionCheckIn />
        <PushNotification />
        <div className="container mb-2 mt-6">
          <h2 className="text-lg font-bold leading-130 text-white mb-1">
            {t("daily_tasks")}
          </h2>
          <HomeTaskList />
        </div>
      </div>
    </PageWrapper>
  );
}
